export function LegalShiftSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight mb-1 font-[family-name:var(--font-heading)]">
        Stop scaling with headcount. Start scaling with AI agents.
      </h2>
      <p className="text-[14px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-5">
        Not a chatbot. Not another system to learn. An AI agent that lives inside the tools your team already uses.
      </p>

      <div className="flex gap-4">
        {[
          {
            heading: "Traditional",
            highlighted: false,
            text: "Hire more staff as caseload grows. Linear cost, linear capacity. Every new hire needs training, supervision, and office space.",
          },
          {
            heading: "Generic AI Tools",
            highlighted: false,
            text: "Chatbots and copilots. Separate systems. No compliance, no audit trail, no workflow integration. Your team still does the real work elsewhere.",
          },
          {
            heading: "AI Paralegal Agent",
            highlighted: true,
            text: "Works inside Slack, Teams, WhatsApp, or email. Specialist skills for document handling, form preparation, and compliance checking. Professionals review and approve. No new tools to learn.",
          },
        ].map((col) => (
          <div
            key={col.heading}
            className="flex-1 flex flex-col rounded-sm overflow-hidden"
            style={{
              border: col.highlighted ? "1px solid var(--color-accent)" : "1px solid var(--color-border)",
              boxShadow: undefined,
            }}
          >
            <div
              className="px-5 py-3 text-[11px] font-[family-name:var(--font-mono)] tracking-widest uppercase"
              style={{
                color: col.highlighted ? "var(--color-accent)" : "var(--color-fg-secondary)",
                borderBottom: "1px solid var(--color-border)",
              }}
            >
              {col.heading}
            </div>
            <div className="flex-1 flex items-start px-5 py-4">
              <p className="text-[13px] leading-relaxed" style={{ color: col.highlighted ? "var(--color-fg)" : "var(--color-fg-secondary)" }}>
                {col.text}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Same conversation. Same workspace. The agent handles operational preparation while professionals handle judgement.
        </p>
      </div>
    </div>
  );
}
